import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import MetaPageViewTracker from "./components/MetaPageViewTracker.tsx";

// Rotas secundárias carregadas sob demanda (reduz bundle inicial)
const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const TermosDeUso = lazy(() => import("./pages/TermosDeUso.tsx"));
const PoliticaDePrivacidade = lazy(() => import("./pages/PoliticaDePrivacidade.tsx"));
const PoliticaDeCookies = lazy(() => import("./pages/PoliticaDeCookies.tsx"));
const Contato = lazy(() => import("./pages/Contato.tsx"));
const Auth = lazy(() => import("./pages/Auth.tsx"));
const AdminContatos = lazy(() => import("./pages/AdminContatos.tsx"));
const ComportamentoEmpreendedor = lazy(() => import("./pages/ComportamentoEmpreendedor.tsx"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe.tsx"));

const queryClient = new QueryClient();

const RouteFallback = () => (
  <div className="min-h-screen bg-background" aria-hidden="true" />
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <MetaPageViewTracker />
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/termos-de-uso" element={<TermosDeUso />} />
            <Route path="/politica-de-privacidade" element={<PoliticaDePrivacidade />} />
            <Route path="/politica-de-cookies" element={<PoliticaDeCookies />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/admin/contatos" element={<AdminContatos />} />
            <Route path="/comportamento-empreendedor" element={<ComportamentoEmpreendedor />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
